import { render, staticRenderFns } from "./KaijuFundsHistoryItem.vue?vue&type=template&id=30c64938&"
import script from "./KaijuFundsHistoryItem.vue?vue&type=script&lang=ts&"
export * from "./KaijuFundsHistoryItem.vue?vue&type=script&lang=ts&"
import style0 from "./KaijuFundsHistoryItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports